import { Skeleton } from "@dash/skeleton";
import { useTheme } from "@emotion/react";
import React from "react";
import tinycolor from "tinycolor2";

const titleWidthPatterns = ["72%", "58%", "84%", "66%"] as const;

export const CubeCollapsedTileSkeletonStack: React.FC = () => {
  const theme = useTheme();
  const tileBorder = `1px solid ${tinycolor(theme.colors.primary).setAlpha(0.1).toRgbString()}`;
  return (
    <div css={{ display: "flex", flexDirection: "column", gap: "0.5rem", width: "100%" }}>
      {titleWidthPatterns.map((titleWidth, index) => (
        <div
          key={index}
          css={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "1rem",
            boxSizing: "border-box",
            width: "100%",
            padding: "0.65rem 1rem",
            borderRadius: theme.smallBorderRadius,
            border: tileBorder,
            backgroundColor: "white",
          }}
        >
          <div css={{ flex: 1, minWidth: 0 }}>
            <Skeleton height="1rem" width={titleWidth} />
          </div>
          <Skeleton height="0.65rem" width="0.65rem" />
        </div>
      ))}
    </div>
  );
};
